import { Reducer } from 'react';
import { Actions } from '../../actions/permissionRoleEdit';
import { Action, PermissionRoleEditState, PermissionByRoleEdit } from '../../types';
import { GetRolePermissions_getPermissionRoles as getPermissionRoles } from '../../../types/schemaTypes';
import { cloneDeep } from 'lodash';

const newPermissionList: PermissionByRoleEdit[] = [];
const oldList = ({} as any) as getPermissionRoles;

const initialPermissionRoleEditState: PermissionRoleEditState = {
    currentValues: oldList,
    toBePosted: newPermissionList,
};

const setInitialData = (data: getPermissionRoles, state: PermissionRoleEditState): PermissionRoleEditState => {
    const copiedOldValues = cloneDeep(data);
    return {
        ...state,
        currentValues: copiedOldValues,
    };
};

const updateGridData = (
    payload: { roleId: number; permissionId: number; editTypeId: boolean },
    state: PermissionRoleEditState,
): PermissionRoleEditState => {
    const toBePosted = cloneDeep(state.toBePosted);
    const currentValues = cloneDeep(state.currentValues);
    toBePosted.push({
        roleId: payload.roleId,
        permissionId: payload.permissionId,
        editTypeId: payload.editTypeId,
    });

    currentValues.categories.map(category => {
        category.permissions.map(permission => {
            if (permission.id === payload.permissionId) {
                permission.assignments.map(assignment => {
                    if (assignment.roleId === payload.roleId) {
                        assignment.isAssigned = payload.editTypeId;
                    }
                });
            }
        });
    });

    return {
        toBePosted: toBePosted,
        currentValues: currentValues,
    };
};

const saveAndClearPostedData = (payload: any, state: PermissionRoleEditState): PermissionRoleEditState => {
    return {
        ...state,
        toBePosted: [],
    };
};

const permissionRoleEditReducer: Reducer<PermissionRoleEditState, Action> = (
    state,
    action,
): PermissionRoleEditState => {
    let newState = { ...state };
    switch (action.type) {
        case Actions.SET_INITIAL_DATA:
            newState = setInitialData(action.payload, state);
            break;
        case Actions.UPDATE_GRID_DATA:
            newState = updateGridData(action.payload, state);
            break;
        case Actions.SAVE_AND_CLEAR_POSTED_DATA:
            newState = saveAndClearPostedData(action.payload, state);
            break;
    }
    return newState;
};

export { initialPermissionRoleEditState, permissionRoleEditReducer };
